module.exports = __webpack_public_path__ + "img/xmg.05e0b15e.svg";